// extracted by mini-css-extract-plugin
module.exports = {"locale":"Form-module__locale___2z8QY","title":"Form-module__title___alO5j"};